
import { Component, Vue } from 'vue-property-decorator'
import http from '@/utils/request'
import { getUserInfo } from '@/utils/user'

@Component
export default class extends Vue {
  loading = false
  data = {
    realName: '',
    accountNumber: '',
    mid: ''
  }

  onConfirm() {
    this.$router.push({ path: '/login' })
  }

  async initData() {
    try {
      this.loading = true
      const data = await http.post('/lend/api/getLenderInfo')
      // console.log(data)
      if (data) {
        this.data.accountNumber = data.accountNumber
        this.data.realName = data.realName

        const { mid } = getUserInfo('userInfoMap') || {}
        this.data.mid = mid
      }
    } catch (e) {
      //
    } finally {
      //
      this.loading = false
    }
  }

  created() {
    this.initData()
  }
}
